const {jQuery: $} = window;
import Utils from "./utils.class";

export default class Products {
    #active = false;
    #$tabArea = null;
    #$tabs = null;
    #$content = null;

    constructor(theme) {
        this.#active = theme.$body.hasClass("single-products");

        if(this.#active) {
            this.#$tabArea = $(".productTabs");
            this.#$tabs = this.#$tabArea.find(".productTabs__tab");
            this.#$content = this.#$tabArea.find(".productTabs__content");

            this.#$tabs.filter(":first").addClass("productTabs__tab--active");
            this.#$content.filter(":first").addClass("productTabs__content--active");
        }
    }

    events() {
        if(!this.#active) return;

        const me = this;

        this.#$tabs.on("click", function () {
            const $this = $(this);
            const tab = $this.attr("data-tab");
            const $active = me.#$content.filter(`[data-tab='${tab}']`);

            if(tab && $active.length) {
                if ($this.hasClass("productTabs__tab--active") && $this.hasClass("productTabs__tab--mobile")) {
                    me.#$tabs.removeClass("productTabs__tab--active");
                    me.#$content.removeClass("productTabs__content--active");

                } else {
                    me.#$tabs.removeClass("productTabs__tab--active");
                    me.#$tabs.filter(`[data-tab='${tab}']`).addClass("productTabs__tab--active");

                    me.#$content.removeClass("productTabs__content--active");
                    me.#$content.filter(`[data-tab='${tab}']`).addClass("productTabs__content--active");
                }
            }
        });
    }
}